export class TaxrateDto {
  public percent: number;
  public id: number;
  public name: string;
  public receiptText: string;
}
